import React from 'react'
import { Grid } from 'semantic-ui-react'
import { H6, Paragraph2 } from '@styles/Global.styles'
import { PlateSizeGuideContainer, PlateSizeGuideHeading, PlateSizeGuidePlate, PlateSizeGuidePlateContainer } from './PlateSizeGuide.styles';

const PlateSizeGuide = () => (
    <PlateSizeGuideContainer>
        <PlateSizeGuideHeading>Plate Size Guide</PlateSizeGuideHeading>
        <Grid>
            <Grid.Row>
                <Grid.Column width={9}>
                    <H6>Standard</H6>
                    <Paragraph2 color='#707070'>360mm x 124mm</Paragraph2>
                </Grid.Column>
                <PlateSizeGuidePlateContainer>
                    <PlateSizeGuidePlate width={360} height={124}></PlateSizeGuidePlate>
                </PlateSizeGuidePlateContainer>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width={9}>
                    <H6>Graphic</H6>
                    <Paragraph2 color='#707070'>360mm x 155mm</Paragraph2>
                </Grid.Column>
                <PlateSizeGuidePlateContainer>
                    <PlateSizeGuidePlate width={360} height={155}></PlateSizeGuidePlate>
                </PlateSizeGuidePlateContainer>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width={9}>
                    <H6>Slim</H6>
                    <Paragraph2 color='#707070'>360mm x 100mm</Paragraph2>
                </Grid.Column>
                <PlateSizeGuidePlateContainer>
                    <PlateSizeGuidePlate width={360} height={100}></PlateSizeGuidePlate>
                </PlateSizeGuidePlateContainer>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width={9}>
                    <H6>European</H6>
                    <Paragraph2 color='#707070'>520mm x 112mm</Paragraph2>
                </Grid.Column>
                <PlateSizeGuidePlateContainer>
                    <PlateSizeGuidePlate width={520} height={112}></PlateSizeGuidePlate>
                </PlateSizeGuidePlateContainer>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width={9}>
                    <H6>American</H6>
                    <Paragraph2 color='#707070'>306mm x 155mm</Paragraph2>
                </Grid.Column>
                <PlateSizeGuidePlateContainer>
                    <PlateSizeGuidePlate width={306} height={155}></PlateSizeGuidePlate>
                </PlateSizeGuidePlateContainer>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width={9}>
                    <H6>Motorcycle</H6>
                    <Paragraph2 color='#707070'>260mm x 100mm</Paragraph2>
                </Grid.Column>
                <PlateSizeGuidePlateContainer>
                    <PlateSizeGuidePlate width={260} height={100}></PlateSizeGuidePlate>
                </PlateSizeGuidePlateContainer>
            </Grid.Row>
        </Grid>
    </PlateSizeGuideContainer>
);

export default PlateSizeGuide